"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnalyticsWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var fwRUMReactAdapter = window.FW_RUM_REACT_ADAPTER;
/*
  We have mimicked the route hooks functionality in ember by placing a parent component for all the pages.
*/

var AnalyticsWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(AnalyticsWrapper, _React$Component);

  var _super = _createSuper(AnalyticsWrapper);

  function AnalyticsWrapper() {
    _classCallCheck(this, AnalyticsWrapper);

    return _super.apply(this, arguments);
  }

  _createClass(AnalyticsWrapper, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      fwRUMReactAdapter.resolveRouteTransition(this.props.name, this.props.location.pathname);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      /*
        Whenever react-router's <Redirect/> is issued during the load of a page, the route
        transition shouldn't be registered since that can report a meaningful paint based
        on the components that render in the intermediate state. Instead, a route transition
        is registered only when the final state is achieved (i.e. history.action !== 'REPLACE').
        This ensures that the meaningful paint that is reported measures the time taken from
        the start of the transition, till the final UI state in the destination route has
        rendered. This also helps avoid explicit tracking of redirects within the host app.
        If registration of route transitions need to be handled differently, the host app
        will need to implement a customized AnalyticsWrapper.
         Note - When <Redirect/> is used with a 'push' prop, history.action is set to 'PUSH'. In
        this case, the route transition WILL get registered since the user also has the option to
        use the browser's 'Back' button to reach the intermediate URL. In such cases, since the
        redirect is possibly conditional (based on some local state) and there is a possibility
        for the intermediate URL to actually load under specific conditions, the route should not
        be skipped.
      */
      if (nextProps.location.pathname !== this.props.location.pathname && nextProps.history.action !== 'REPLACE') {
        fwRUMReactAdapter.resolveRouteTransition(nextProps.name, nextProps.location.pathname);
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var page = this.props.page;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(page, this.props));
    }
  }]);

  return AnalyticsWrapper;
}(_react.default.Component);

var AnalyticsWrapperWithRouter = (0, _reactRouterDom.withRouter)(AnalyticsWrapper);
exports.AnalyticsWrapper = AnalyticsWrapperWithRouter;

var withAnalytics = function withAnalytics(name, page, props) {
  return /*#__PURE__*/_react.default.createElement(AnalyticsWrapperWithRouter, _extends({
    name: name,
    page: page
  }, props));
};

var _default = withAnalytics;
exports.default = _default;